import ActionTypes from "../../enums/ActionTypes"

// please remove after project and orderPosition migration
export const fetchCustomers = () => ({
  type: ActionTypes.BASEDATA_CUSTOMERS_LIST_REQUEST,
})
